<template>
    <div class="wrapper">
<!--        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="加载上一个" style="height:100%">-->
<!--             <van-list-->
<!--                style="height:100%"-->
<!--                v-model="loading"-->
<!--                :finished="finished"-->
<!--                :offset="-10"-->
<!--                @load="onLoad"-->
<!--            >-->
             <div class="content" id="videopay">
                <div class="option-box" @click="handleGoList">
                    <van-icon name="arrow-left" size="30" color="#FFFFFF"/>
                </div>
                <div class="video-box" >
                    <video :src="videoInfo.video_url"
                        style="width: 100%;height:100%;-o-object-fit: cover;object-fit: cover;height: 100%"
                        id="video"
                        preload="auto"
                        type="video/mp4"
                        :poster="videoInfo.logo"
                        webkit-playsinline=""
                        playsinline=""
                        x5-video-player-fullscreen="false"
                        x5-video-player-type="false"
                    >
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
                <div class="info-box">
                    <div class="head-img-box">
                        <img :src="videoInfo.logo" alt="" style="width: 40px;height: 40px;border-radius: 50%">
                    </div>
                    <!-- <div class="like-box">
                        <van-icon name="like-o" v-if="videoInfo.is_like === 0" @click="setLikeVideo" size="40"/>
                        <van-icon name="like" v-else color="#f40" @click="setLikeVideo" size="40"/>
                    </div> -->
                    <div class="share-box">
                        <van-icon name="share" size="40"  @click="handelShare" />
                    </div>
                    <div class="base-info-box">
                        <!-- <div class="link-href-box" @click="handleGoLike">
                            <van-icon name="cart" color="#fff"/>
                            {{videoInfo.title}}
                        </div> -->
                        <!-- <div class="video-author">
                            {{videoInfo.send_name}}
                        </div> -->
                        <div class="video-title" @click="handleGoLike">
							<div style="font-size: 14px;font-weight: bold;margin-bottom: 5px;">{{videoInfo.name}}</div>
                            {{videoInfo.name}}
                        </div>
                    </div>
                </div>

                <div class="play" @click="handelPay" v-show="isShow">
                    <img v-if="active" src="../../assets/img/icon/icon-play.png" alt="" style="width: 30px;height: 30px">
                    <img v-else src="../../assets/img/icon/icon-stop.png" alt="" style="width: 30px;height: 30px">
                </div>
            </div>

<!--             </van-list>-->

<!--        </van-pull-refresh>-->
       

        <van-popup v-model="show" @click="show = false">
            <img style="width: 100%" src="../../assets/img/icon/share-video.png" alt="">
        </van-popup>
        <van-overlay :show="showO" >
            <van-loading size="24px">加载中</van-loading>
        </van-overlay>
    </div>
</template>

<script>
    import {getShopVideoDetailsService, setLikeVideoService} from "../../service/videoService";
    import {mapState} from "vuex";
    import {Dialog, Toast} from "vant";
    import {getWxSharService} from "../../service/weChatService";
    import wx from "weixin-js-sdk";
	import {wecharShare} from "../../util/weChat.js";
    export default {
        name: "VideoPlay",
        data(){
            return{
                videoId:null,
                videoInfo:{},
                active:false,
                isShow:true,
                show:false,
                type:0,
                lock:true,
                showO:false,
                handle1:null,
                isLoading: false,


                loading: false,
                finished: false,
				distance: ''
            }
        },
        mounted() {
            this.videoId = this.$route.params.id;
            this.distance = this.$route.params.distance;
            this.scolly();
            this.getVideoDetails();
            // this.doemFn();
            sessionStorage.setItem('isOk',1);
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{

            doemFn(){
                document.getElementById('videopay').addEventListener('touchstart',event => {
                    var touch = event.originalEvent,
                        startX = event.touches[0].pageX,
                        startY = event.touches[0].pageY;
                    document.getElementById('videopay').addEventListener('touchend',function (event) {
                        var spanX = event.changedTouches[0].pageX - startX;
                        var spanY = event.changedTouches[0].pageY - startY;
                        console.log(spanX)
                        console.log(spanY)
                        if(Math.abs(spanX) < Math.abs(spanY)) { //认定为水平方向滑动
                            //认定为垂直方向滑动
                            console.log(spanY)
                            if(spanY > 20) { //向下
                                console.log("向下")
                            } else if(spanY < -30) { //向上
                                console.log("向上")
                            }
                        }
                    })
                })
                // document.getElementById('videopay').on('touchstart',event => {
                //     var touch = event.originalEvent,
                //         startX = event.touches[0].pageX;
                //     startY = event.touches[0].pageY;
                //     document.getElementById('videopay').on('touchend', function(event) {
                //         var spanX = event.changedTouches[0].pageX - startX;
                //         var spanY = event.changedTouches[0].pageY - startY;
                //         if(Math.abs(spanX) < Math.abs(spanY)) { //认定为水平方向滑动
                //             //认定为垂直方向滑动
                //             console.log(spanY)
                //             if(spanY > 20) { //向下
                //                 console.log("向下")
                //                 $(".index-top-img3").hide();
                //             } else if(spanY < -30) { //向上
                //                 console.log("向上")
                //                 $(".index-top-img3").show();
                //             }
                //         }
                //     });
                // })
            },
            onRefresh(){
                console.log(111)
                this.type = 1;
                this.getVideoDetails();

            },

            onLoad(){
                console.log('onLoad');

            },
            //获取视频详情
            getVideoDetails(){
                this.showO = true;
                getShopVideoDetailsService(this.userId,this.videoId,this.type).then(res => {
                    if(res.status === 1){
                        this.videoInfo = res.datas;
                        this.videoId = res.datas.id;
                        this.share();
                        
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    this.showO = false;
                    this.isLoading = false;
                    setTimeout(()=> {
                        this.lock = true;
                    },2000)
                });
            },

            //添加喜欢的视频
            setLikeVideo(){
                if(!this.userId){
                    Dialog.confirm({
                        title:'提示',
                        message:'您还未登录，前去登录',
                    }).then(() => {
                        this.$router.push({
                            name:'userLogin'
                        })
                    }).catch(() => {})
                }else{
                    setLikeVideoService(this.userId,this.videoInfo.id).then(res => {
                        if(res.status === 1){
                            if(this.videoInfo.is_like === 0){
                                Toast('添加成功');
                                this.videoInfo.is_like = 1;
                            }else{
                                Toast('删除成功');
                                this.videoInfo.is_like = 0;
                            }
                        }
                    }).catch(err => {
                        console.log(err);
                    }).finally(() => {});
                }
            },

            //分享
            handelShare(){
                this.show = true;
                clearTimeout(timer);
                const timer = setTimeout(() => {
                    // this.show = false;
                },1500)
                console.log('分享');
            },

            //播放视频
            handelPay(){
                if(this.active){//暂停
                    this.active = false;
                    document.getElementById('video').pause();
                }else{//播放
                    this.active = true;
                    document.getElementById('video').play();
                }
                console.log(this.active);
            },

            //手指离开屏幕
            handleTouchend(){
                this.isShow = false;
            },

            //手指在屏幕上移动
            handleTouchmove(){
                this.isShow = true;
            },

            handleGoList(){
                this.$router.go(-1);
            },


            handleGoLike(){
				console.log(distance);
				var shopId = this.videoId; 
				var distance = this.distance;
				this.$router.push({
					name: 'newshopdetail', //shopDetails
					params: {
						shopId,
						distance,
					}
				})
            },


            share(){
                const that = this;
                getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
                    if (result.status === 1) {
                        wx.config({
                            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            'appId': result.datas.appId, // 公众号名称，由商户传入
                            'timestamp': result.datas.timestamp, // 时间戳，自1970年以来的秒数
                            'nonceStr': result.datas.nonceStr, // 随机串
                            'signature': result.datas.signature,// 微信签名
                            'jsApiList': ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
                        });
                        wx.ready(function () {
                            //分享到朋友圈
                            wx.updateTimelineShareData({
                                title: that.videoInfo.title, // 分享标题
                                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: that.videoInfo.cover_img, // 分享图标
                                success: function () {
                                    // Toast('分享成功');
                                }
                            });
                            //分享给朋友
                            wx.updateAppMessageShareData({
                                title: '收到乐', // 分享标题
                                desc: that.videoInfo.title || '',//分享描述
                                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: that.videoInfo.cover_img, // 分享图标
                                success: function () {
                                    // Toast('分享成功');
                                }
                            });
                        });
                    } else {
                        Toast(result.msg);
                    }
                })
            },


            scolly(){
                const that = this;
                var h = document.documentElement.clientHeight,
                mybody = document.getElementsByClassName('video-box')[0];
                mybody.style.height = h + 'px';
                //返回角度
                function GetSlideAngle(dx, dy) {
                    return Math.atan2(dy, dx) * 180 / Math.PI;
                }
                //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
                function GetSlideDirection(startX, startY, endX, endY) {
                    var dy = startY - endY;
                    var dx = endX - startX;
                    var result = 0;
                    //如果滑动距离太短
                    if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {

                        return result;

                    }
                    var angle = GetSlideAngle(dx, dy);
                    if (angle >= -45 && angle < 45) {

                        result = 4;

                    } else if (angle >= 45 && angle < 135) {
                        result = 1;
                    } else if (angle >= -135 && angle < -45) {
                        result = 2;
                    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
                        result = 3;
                    }
                    return result;
                }

                //滑动处理
                var startX, startY;

                mybody.addEventListener('touchstart', function (ev) {
                    ev.preventDefault();
                    startX = ev.touches[0].pageX;
                    startY = ev.touches[0].pageY;
                }, false);

                mybody.addEventListener('touchend', function (ev) {
                    console.log()
                    if(sessionStorage.getItem('isOk') == 1){
                        console.log(that.lock)
                        if(!that.lock){
                            return;
                        }
                        var endX, endY;
                        ev.preventDefault();
                        endX = ev.changedTouches[0].pageX;
                        endY = ev.changedTouches[0].pageY;
                        var direction = GetSlideDirection(startX, startY, endX, endY);
                        switch (direction) {
                            case 0:
                                // alert("没滑动");
                                break;
                            case 1:
                                that.type = 1;
                                // alert("向上");
                                break;
                            case 2:
                                that.type = 2;
                                // alert("向下");
                                break;
                            case 3:
                                // alert("向左");
                                break;
                            case 4:
                                // alert("向右");
                                break;
                            default:
                        }
                        that.lock = false;
                        
                        that.getVideoDetails();
                    }
                    

                }, false);
                that.handle1 = function(ev){
                    
                }

            },

        },
        destroyed(){
             sessionStorage.setItem('isOk',2);
             document.getElementsByTagName('body')[0].removeEventListener('touchend',this.handle1,false);
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
            }),
        },
    }
</script>

<style scoped lang="scss">

    .wrapper{
        height: 100%;
        width: 100%;
        position: relative;
        .content{
            height: 100%;
            width: 100%;
            position: relative;
            .option-box{
                position: absolute;
                top: 40px;
                left: 20px;
                z-index: 99;
            }
            .video-box{
                height: 100%;
                width: 100%;
            }
            .info-box{
                /*position: absolute;*/
                /*width: 100%;*/
                /*padding: 0 20px;*/
                /*box-sizing: border-box;*/
                .head-img-box,
                .like-box,
                .share-box{
                    text-align: right;
                    padding: 10px 0;
                    position: absolute;
                    right: 10px;

                }
                .head-img-box{
                    bottom: 140px;
                }
                .like-box{
                    bottom: 80px;
                }
                .share-box{
                    bottom: 30px;
                }


                .base-info-box{
                    position: absolute;
                    bottom: 30px;
                    left: 10px;
                    .link-href-box{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        box-sizing: border-box;
                        font-size: 16px;
                        color: #00BFFF;
						font-weight: bold;
                        // color: #fff;
                        /*background:linear-gradient(360deg,rgba(203,203,203,0.1) 0%,rgba(32,32,32,1) 100%);*/
                        /*opacity:0.39;*/
                    }
                    .video-author{
                        margin-top: 20px;
                        color: #ffffFF;
                    }
                    .video-title{
                        color: #fff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        // white-space: nowrap;
						padding: 5px;
						border-radius: 5px;
						background-color: #303030;
						word-wrap:break-word;
						word-break:normal; 
						font-size: 12px;
						filter:alpha(Opacity=60);
						-moz-opacity:0.6;
						opacity: 0.8;
						max-width: 260px;
                    }
                }
            }
            .play{
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -15px;
                margin-top: -15px;
            }
        }
    }
</style>
<style scoped>
    .van-popup--center{
        background: transparent;
    }
</style>